export default "__VITE_ASSET__9329f81e__"